<div class="pos-diagnostics-list">
  <div class="row mb-3 align-items-center">
    <div class="col-md-5">
      <span class="text-muted" *ngIf="!isLoading && !endpointUnavailable">
        {{ totalItems }} event{{ totalItems === 1 ? '' : 's' }} found
        <span *ngIf="events.length > 0">
          · {{ errorEventsOnPage }} error-class on page
          <span *ngIf="labelledEventsOnPage > 0"> · {{ labelledEventsOnPage }} labelled (excluded from error rate)</span>
        </span>
      </span>
    </div>
    <div class="col-md-7">
      <div class="d-flex align-items-center justify-content-end flex-wrap gap-2 auto-refresh-bar">
        <nb-toggle
          [(checked)]="autoRefreshEnabled"
          (checkedChange)="toggleAutoRefresh()"
          status="primary">
          Auto-refresh
        </nb-toggle>
        <nb-select
          [(selected)]="refreshIntervalSec"
          (selectedChange)="onRefreshIntervalChange()"
          size="small"
          placeholder="Interval">
          <nb-option [value]="15">15 s</nb-option>
          <nb-option [value]="30">30 s</nb-option>
          <nb-option [value]="60">1 min</nb-option>
          <nb-option [value]="120">2 min</nb-option>
        </nb-select>
        <span *ngIf="autoRefreshEnabled" class="text-muted small text-nowrap">
          Next in {{ countdown }}s
        </span>
        <button class="btn btn-outline-secondary btn-sm" (click)="loadEvents()">
          <nb-icon icon="refresh-outline"></nb-icon>
          Refresh
        </button>
      </div>
    </div>
  </div>

  <nb-card class="mb-4">
    <nb-card-body>
      <div class="row align-items-end g-3">
        <div class="col-md-2">
          <label class="form-label">From</label>
          <input type="date" class="form-control" [(ngModel)]="dateFrom" (change)="onFilterChange()">
        </div>
        <div class="col-md-2">
          <label class="form-label">To</label>
          <input type="date" class="form-control" [(ngModel)]="dateTo" (change)="onFilterChange()">
        </div>
        <div class="col-md-2">
          <label class="form-label">Level</label>
          <select class="form-select" [(ngModel)]="selectedLevel" (change)="onFilterChange()">
            <option *ngFor="let opt of levelOptions" [value]="opt.value">{{ opt.label }}</option>
          </select>
        </div>
        <div class="col-md-2">
          <label class="form-label">Event type</label>
          <select class="form-select" [(ngModel)]="selectedEventType" (change)="onFilterChange()">
            <option *ngFor="let opt of eventTypeOptions" [value]="opt.value">{{ opt.label }}</option>
          </select>
        </div>
        <div class="col-md-2">
          <label class="form-label">Build commit</label>
          <input type="text" class="form-control font-monospace small" [(ngModel)]="buildCommit"
            placeholder="abc1234" (keyup.enter)="onFilterChange()">
        </div>
        <div class="col-md-2">
          <label class="form-label">Terminal ID</label>
          <input type="text" class="form-control font-monospace small" [(ngModel)]="terminalId"
            placeholder="192.168.0.101" (keyup.enter)="onFilterChange()">
        </div>
        <div class="col-md-4">
          <label class="form-label">Search</label>
          <input type="text" class="form-control" [(ngModel)]="searchText"
            placeholder="Message, operation, route…" (keyup.enter)="onFilterChange()">
        </div>
        <div class="col-md-2">
          <label class="form-label">Page size</label>
          <select class="form-select" [(ngModel)]="pageSize" (change)="onPageSizeChange()">
            <option *ngFor="let size of pageSizeOptions" [value]="size">{{ size }}</option>
          </select>
        </div>
        <div class="col-md-2">
          <button class="btn btn-outline-secondary w-100" (click)="resetFilters()">Reset filters</button>
        </div>
      </div>
    </nb-card-body>
  </nb-card>

  <div *ngIf="endpointUnavailable" class="alert alert-info d-flex align-items-start gap-2 mb-4">
    <nb-icon icon="info-outline"></nb-icon>
    <div>
      <strong>Backend not ready</strong>
      <p class="mb-0 small">{{ errorMessage }}</p>
    </div>
  </div>

  <nb-card>
    <nb-card-header *ngIf="!isLoading && !errorMessage && errorEvents.length > 0" class="py-2">
      <strong>Errors &amp; warnings</strong>
      <span class="text-muted small ms-2">Real diagnostic issues — counted toward error metrics</span>
    </nb-card-header>
    <nb-card-body class="p-0">
      <div class="table-responsive" *ngIf="!isLoading && !errorMessage && errorEvents.length > 0">
        <table class="table table-hover mb-0">
          <thead class="table-light">
            <tr>
              <th>Time</th>
              <th>Level</th>
              <th>Event type</th>
              <th>Message</th>
              <th>Terminal</th>
              <th>Build</th>
              <th>Session</th>
              <th></th>
            </tr>
          </thead>
          <tbody>
            <tr *ngFor="let event of errorEvents; trackBy: trackByEventId"
              [class.error-row]="isErrorLevel(event.level)"
              [class.critical-row]="isCriticalFinancialEvent(event)">
              <td class="text-nowrap small">
                {{ (event.occurredAt || event.createdAt) | date:'dd/MM/yyyy HH:mm:ss' }}
              </td>
              <td>
                <span class="badge" [ngClass]="getLevelBadgeClass(event.level)">{{ event.level || '—' }}</span>
              </td>
              <td class="small">
                <span class="badge" [ngClass]="getEventTypeBadgeClass(event.eventType)">
                  {{ getEventTypeLabel(event.eventType) }}
                </span>
              </td>
              <td class="message-cell small">{{ event.message || '—' }}</td>
              <td class="font-monospace small">
                {{ event.context?.terminalId || event.terminalId || '—' }}
              </td>
              <td class="font-monospace small">
                {{ (event.context?.commit || event.buildCommit || '—') | slice:0:8 }}
              </td>
              <td>
                <button *ngIf="event.diagnosticSessionId"
                  class="btn btn-link btn-sm p-0 font-monospace"
                  (click)="openSessionTimeline(event.diagnosticSessionId); $event.stopPropagation()"
                  nbTooltip="View full session timeline">
                  {{ event.diagnosticSessionId | slice:0:8 }}…
                </button>
                <span *ngIf="!event.diagnosticSessionId" class="text-muted">—</span>
              </td>
              <td>
                <button class="btn btn-sm btn-outline-primary" (click)="viewEventDetail(event)">
                  <nb-icon icon="eye-outline"></nb-icon>
                  Detail
                </button>
              </td>
            </tr>
          </tbody>
        </table>
      </div>

      <div *ngIf="isLoading" class="text-center p-4">
        <nb-spinner size="large"></nb-spinner>
        <p class="mt-2 text-muted">Loading diagnostics events…</p>
      </div>

      <div *ngIf="!isLoading && errorMessage && !endpointUnavailable" class="text-center p-4">
        <nb-icon icon="alert-circle-outline" class="text-danger" style="font-size: 2rem;"></nb-icon>
        <p class="mt-2 text-danger">{{ errorMessage }}</p>
        <button class="btn btn-outline-secondary btn-sm" (click)="loadEvents()">Try again</button>
      </div>

      <div *ngIf="!isLoading && !errorMessage && events.length === 0" class="text-center p-4">
        <nb-icon icon="checkmark-circle-2-outline" style="font-size: 2.5rem;" class="text-muted mb-2"></nb-icon>
        <h5>No diagnostic events</h5>
        <p class="text-muted">No events match your filters, or kiosks have not reported any issues yet.</p>
      </div>

      <div *ngIf="!isLoading && !errorMessage && errorEvents.length === 0 && labelledEvents.length > 0" class="text-center p-4 border-top">
        <p class="text-muted mb-0">No real errors on this page — only labelled/expected events below.</p>
      </div>

      <div *ngIf="!isLoading && totalPages > 1" class="d-flex justify-content-between align-items-center p-3 border-top">
        <span class="text-muted">
          Showing {{ (currentPage - 1) * pageSize + 1 }}–{{ Math.min(currentPage * pageSize, totalItems) }} of {{ totalItems }}
        </span>
        <div>
          <button class="btn btn-outline-secondary me-2" [disabled]="currentPage === 1"
            (click)="onPageChange(currentPage - 1)">Previous</button>
          <span class="me-2">Page {{ currentPage }} of {{ totalPages }}</span>
          <button class="btn btn-outline-secondary" [disabled]="currentPage === totalPages"
            (click)="onPageChange(currentPage + 1)">Next</button>
        </div>
      </div>
    </nb-card-body>
  </nb-card>

  <nb-card *ngIf="!isLoading && !errorMessage && labelledEvents.length > 0" class="mt-4 labelled-events-card">
    <nb-card-header class="py-2 labelled-events-header">
      <strong>Labelled / expected events</strong>
      <span class="text-muted small ms-2">Informational only — not counted toward error rate or alerts</span>
    </nb-card-header>
    <nb-card-body class="p-0">
      <div class="table-responsive">
        <table class="table table-hover mb-0 labelled-events-table">
          <thead class="table-light">
            <tr>
              <th>Time</th>
              <th>Label</th>
              <th>Details</th>
              <th>Terminal</th>
              <th>Build</th>
              <th>Session</th>
              <th></th>
            </tr>
          </thead>
          <tbody>
            <tr *ngFor="let event of labelledEvents; trackBy: trackByEventId" class="labelled-row">
              <td class="text-nowrap small">
                {{ (event.occurredAt || event.createdAt) | date:'dd/MM/yyyy HH:mm:ss' }}
              </td>
              <td class="small">
                <span class="badge labelled-event-badge bg-info text-dark">
                  {{ getLabelledEventLabel(event) }}
                </span>
              </td>
              <td class="message-cell small">
                <span *ngIf="event.eventType === 'scan_unmatched' && event.context?.barcode">
                  Barcode: <code>{{ event.context.barcode }}</code>
                </span>
                <span *ngIf="event.eventType === 'expected_rejection' && event.context?.scanKind">
                  Scan kind: {{ event.context.scanKind }}
                </span>
                <span *ngIf="!event.context?.barcode && !event.context?.scanKind">
                  {{ event.message || '—' }}
                </span>
              </td>
              <td class="font-monospace small">
                {{ event.context?.terminalId || event.terminalId || '—' }}
              </td>
              <td class="font-monospace small">
                {{ (event.context?.commit || event.buildCommit || '—') | slice:0:8 }}
              </td>
              <td>
                <button *ngIf="event.diagnosticSessionId"
                  class="btn btn-link btn-sm p-0 font-monospace"
                  (click)="openSessionTimeline(event.diagnosticSessionId); $event.stopPropagation()"
                  nbTooltip="View full session timeline">
                  {{ event.diagnosticSessionId | slice:0:8 }}…
                </button>
                <span *ngIf="!event.diagnosticSessionId" class="text-muted">—</span>
              </td>
              <td>
                <button class="btn btn-sm btn-outline-secondary" (click)="viewEventDetail(event)">
                  <nb-icon icon="eye-outline"></nb-icon>
                  Detail
                </button>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </nb-card-body>
  </nb-card>
</div>

<!-- Detail modal -->
<nb-card *ngIf="showDetail && selectedEvent" class="modal-overlay modal-wide">
  <nb-card-header class="d-flex justify-content-between align-items-center flex-wrap gap-2">
    <div class="d-flex align-items-center gap-2 flex-wrap">
      <h5 class="mb-0">Diagnostic Event</h5>
      <span class="badge" [ngClass]="getLevelBadgeClass(selectedEvent.level)">{{ selectedEvent.level }}</span>
      <span class="badge" [ngClass]="getEventTypeBadgeClass(selectedEvent.eventType)">
        {{ isLabelledEvent(selectedEvent) ? getLabelledEventLabel(selectedEvent) : getEventTypeLabel(selectedEvent.eventType) }}
      </span>
      <span class="text-muted small" *ngIf="selectedEvent.occurredAt || selectedEvent.createdAt">
        {{ (selectedEvent.occurredAt || selectedEvent.createdAt) | date:'dd/MM/yyyy HH:mm:ss' }}
      </span>
    </div>
    <button class="btn btn-ghost" (click)="closeDetail()">
      <nb-icon icon="close-outline"></nb-icon>
    </button>
  </nb-card-header>

  <nb-card-body class="modal-body">
    <div *ngIf="loadingDetail" class="text-center p-3">
      <nb-spinner size="medium"></nb-spinner>
      <p class="mt-2 text-muted small">Loading full event detail…</p>
    </div>

    <div *ngIf="!loadingDetail">
      <div *ngIf="detailError" class="alert alert-warning small mb-3">{{ detailError }}</div>

      <div class="alert alert-danger financial-critical-alert d-flex align-items-start gap-2 mb-4"
        *ngIf="isCriticalFinancialEvent(selectedEvent)">
        <nb-icon icon="credit-card-outline"></nb-icon>
        <div>
          <strong>Payment without order</strong>
          <p class="mb-1">{{ selectedEvent.message }}</p>
          <p class="mb-0 small">
            The kiosk reported that the card terminal approved a charge but no order was saved.
            This is a kiosk-reported diagnostic event — not the same figure as terminal-health log aggregates.
          </p>
        </div>
      </div>

      <div class="alert alert-danger d-flex align-items-start gap-2 mb-4"
        *ngIf="selectedEvent.level === 'error' && !isCriticalFinancialEvent(selectedEvent)">
        <nb-icon icon="alert-triangle-outline"></nb-icon>
        <div>
          <strong>{{ selectedEvent.message }}</strong>
          <p class="mb-0 small text-muted" *ngIf="selectedEvent.operation">Operation: {{ selectedEvent.operation }}</p>
          <p class="mb-0 small text-muted" *ngIf="selectedEvent.elapsedMs != null">Elapsed: {{ selectedEvent.elapsedMs }} ms</p>
        </div>
      </div>

      <p *ngIf="selectedEvent.level !== 'error'" class="lead-message mb-4">
        <strong>{{ selectedEvent.message }}</strong>
        <span class="text-muted small d-block" *ngIf="selectedEvent.operation">Operation: {{ selectedEvent.operation }}</span>
      </p>

      <!-- Stack trace -->
      <div class="detail-section mb-4">
        <h6 class="section-label">Stack trace</h6>
        <div *ngIf="isSymbolicated(selectedEvent) && getStackFrames(selectedEvent).length > 0" class="stack-frames">
          <div *ngFor="let frame of getStackFrames(selectedEvent); let i = index"
            class="stack-frame"
            [class.frame-irrelevant]="frame.relevant === false"
            [class.frame-inlined]="frame.inlined">
            <span class="frame-index text-muted">{{ i + 1 }}</span>
            <div class="frame-body">
              <code class="frame-location">{{ frame.file }}:{{ frame.line }}<span *ngIf="frame.column != null">:{{ frame.column }}</span></code>
              <span class="frame-symbol">{{ frame.symbol || '—' }}</span>
              <span *ngIf="frame.inlined" class="badge bg-light text-muted border ms-1">inlined</span>
            </div>
          </div>
        </div>
        <div *ngIf="!isSymbolicated(selectedEvent)" class="unsymbolicated-stack">
          <div class="alert alert-secondary py-2 px-3 small mb-2">
            <nb-icon icon="info-outline" class="me-1"></nb-icon>
            No source map available for build <code>{{ getContext(selectedEvent).commit || 'unknown' }}</code>.
            Showing raw minified trace.
          </div>
          <pre class="json-block font-monospace">{{ getRawStack(selectedEvent) || 'No stack trace captured.' }}</pre>
        </div>
        <p *ngIf="isSymbolicated(selectedEvent) && getStackFrames(selectedEvent).length === 0" class="text-muted small">
          Symbolication succeeded but no frames were returned.
        </p>
      </div>

      <!-- Breadcrumbs -->
      <div class="detail-section mb-4" *ngIf="getBreadcrumbs(selectedEvent).length > 0">
        <h6 class="section-label">Breadcrumb trail</h6>
        <div class="breadcrumb-trail">
          <div *ngFor="let crumb of getBreadcrumbs(selectedEvent)" class="breadcrumb-item">
            <div class="crumb-icon">
              <nb-icon [icon]="getBreadcrumbIcon(crumb.kind)"></nb-icon>
            </div>
            <div class="crumb-content">
              <span class="badge bg-light text-dark border crumb-kind">{{ crumb.kind }}</span>
              <span class="crumb-time text-muted small">{{ crumb.at | date:'HH:mm:ss.SSS' }}</span>
              <p class="crumb-detail mb-0 small">{{ crumb.detail }}</p>
            </div>
          </div>
        </div>
      </div>

      <!-- Log tail -->
      <div class="detail-section mb-4" *ngIf="getLogTail(selectedEvent).length > 0">
        <h6 class="section-label">Log tail ({{ getLogTail(selectedEvent).length }} lines)</h6>
        <pre class="log-tail font-monospace">{{ getLogTail(selectedEvent).join('\n') }}</pre>
      </div>

      <!-- Context envelope -->
      <div class="detail-section mb-4">
        <h6 class="section-label">Context</h6>
        <div class="row">
          <div class="col-md-6">
            <p class="small mb-1"><strong>Build commit:</strong>
              <code class="ms-1">{{ getContext(selectedEvent).commit || '—' }}</code>
            </p>
            <p class="small mb-1"><strong>Build date:</strong> {{ getContext(selectedEvent).buildDate || '—' }}</p>
            <p class="small mb-1"><strong>Flavor:</strong> {{ getContext(selectedEvent).flavor || '—' }}</p>
            <p class="small mb-1"><strong>Route:</strong> <code>{{ getContext(selectedEvent).route || '—' }}</code></p>
          </div>
          <div class="col-md-6">
            <p class="small mb-1"><strong>Store ID:</strong> <code>{{ getContext(selectedEvent).storeId || storeId }}</code></p>
            <p class="small mb-1"><strong>POS session:</strong> <code>{{ selectedEvent.posSessionId || '—' }}</code></p>
            <p class="small mb-1"><strong>Diagnostic session:</strong>
              <button *ngIf="selectedEvent.diagnosticSessionId" class="btn btn-link btn-sm p-0 align-baseline"
                (click)="openSessionTimeline(selectedEvent.diagnosticSessionId)">
                {{ selectedEvent.diagnosticSessionId }}
              </button>
              <span *ngIf="!selectedEvent.diagnosticSessionId">—</span>
            </p>
            <p class="small mb-1"><strong>Terminal:</strong> <code>{{ getContext(selectedEvent).terminalId || '—' }}</code></p>
            <p class="small mb-1"><strong>Cart ID:</strong> <code>{{ selectedEvent.cartId || '—' }}</code></p>
          </div>
        </div>
      </div>

      <!-- Cart snapshot -->
      <div class="detail-section mb-2" *ngIf="getCartSnapshot(selectedEvent) as cart">
        <h6 class="section-label">Cart snapshot at event time</h6>
        <div class="cart-snapshot-card">
          <div class="cart-stat">
            <span class="cart-stat-value">{{ cart.items ?? '—' }}</span>
            <span class="cart-stat-label">items</span>
          </div>
          <div class="cart-stat">
            <span class="cart-stat-value">{{ formatCurrency(cart.total) }}</span>
            <span class="cart-stat-label">total</span>
          </div>
          <p class="text-muted small mb-0 mt-2">
            Shopping carts expire after 24 hours — this snapshot may be the only surviving basket record.
          </p>
        </div>
      </div>

      <!-- Perf metrics if present -->
      <div class="detail-section" *ngIf="selectedEvent.perf">
        <h6 class="section-label">Performance sample</h6>
        <pre class="json-block">{{ prettyJson(selectedEvent.perf) }}</pre>
      </div>
    </div>
  </nb-card-body>
</nb-card>
